import CryptoJS from 'crypto-js'

const password = 'rdxHsW4Cg27yIAjE0nmELMvrpapJzJD3'
const iv = 'rDaFHH76C0B2YhUl'

export function encrypt(text) {
  const encryptText = `${text}-${new Date().getTime()}`

  return CryptoJS.AES.encrypt(encryptText, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(password)), {
    iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString()
}

export function decrypt(text) {
  const ciphertext = CryptoJS.AES.decrypt(text, CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(password)), {
    iv: CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(iv)),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })

  return ciphertext.toString(CryptoJS.enc.Utf8)
}

export function decryptText(text, aesKey, aesIv) {
  const ciphertext = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(aesKey), {
    iv: CryptoJS.enc.Utf8.parse(aesIv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })

  return ciphertext.toString(CryptoJS.enc.Utf8)
}
